import { Outlet } from 'react-router-dom';

export function UsersOutlet() {
  return <Outlet />;
}
